import React from "react"

import { useSelector } from "react-redux"
import { IRedux } from "../../../services/types"
import AddUserTable from "./addUser.table"
import CreateUser from "./createUser"

const AddUser = () => {
  const creationMode = useSelector(
    (state: IRedux) => state.inscription.creationMode
  )

  return <div>{creationMode ? <CreateUser /> : <AddUserTable />}</div>
}

export default AddUser
